/**
 * Reads `name`'s value out of a `Cookie:` header or `document.cookie` string.
 * Parses key=value pairs rather than substring-matching so values like `10` or
 * `12` cannot accidentally satisfy a check for value `1`.
 */
export const readCookieValue = (
    cookieString: string | null | undefined,
    name: string,
): string | undefined => {
    if (!cookieString) {
        return undefined;
    }
    for (const segment of cookieString.split(';')) {
        const [rawKey, ...rawValue] = segment.split('=');
        if (rawKey?.trim() === name) {
            return rawValue.join('=').trim();
        }
    }
    return undefined;
};

/**
 * Reads `name` from an explicit cookie string when given one (SSR, where the
 * `Cookie:` header is the only source), otherwise from `document.cookie`.
 * Returns undefined on the server when no header is passed.
 */
export const readCookieEverywhere = (
    name: string,
    cookieHeader?: string | null,
): string | undefined => {
    const fromHeader = readCookieValue(cookieHeader, name);
    if (fromHeader !== undefined) {
        return fromHeader;
    }
    if (typeof document === 'undefined') {
        return undefined;
    }
    return readCookieValue(document.cookie, name);
};
